// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3uDFY","balanceDisclaimer":"posDashboard_balanceDisclaimer__37sUS"};